import { Link, LinkProps } from '@reach/router';
import React from 'react';
import { useSafeNavigate } from '../../context/SafeNavigate/SafeNavigateProvider';

type OwnProps = {
  children: React.ReactNode;
  to: string;
} & LinkProps<any>;

type ComponentProps = OwnProps & React.HTMLAttributes<HTMLAnchorElement>;

const SafeLink: React.FC<ComponentProps> = React.forwardRef<
  HTMLAnchorElement,
  ComponentProps
>(({ to, children, ...restProps }, ref) => {
  const { navigateWithConfirmation } = useSafeNavigate();
  return (
    <Link
      {...restProps}
      to={to}
      ref={ref as any}
      onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        navigateWithConfirmation?.(to, e as any);
      }}
    >
      {children}
    </Link>
  );
});

export default SafeLink;
